import { FaSignOutAlt } from "react-icons/fa";

import { toAbsoluteUrl } from "@/../_metronic/helpers";

import { useAuth } from "@/modules/auth";
import { shortName } from "@/utils/shortName";

/* eslint-disable jsx-a11y/anchor-is-valid */
const AsideToolbar = () => {
	const { currentAuth, logout } = useAuth();
	const name = shortName(currentAuth?.user.name);

	return (
		<div className="aside-user d-flex align-items-sm-center justify-content-center py-5">
			<div className="symbol symbol-50px">
				<img src={toAbsoluteUrl("/media/avatars/300-1.jpg")} alt="" />
			</div>

			<div className="aside-user-info flex-row-fluid flex-wrap ms-5">
				<div className="d-flex">
					<div className="flex-grow-1 me-2">
						<span className="text-gray-800 fs-6 fw-bold text-capitalize">
							{name}
						</span>
					</div>

					<div className="me-n2">
						<a
							href="#"
							className="btn btn-icon btn-sm btn-active-color-primary mt-n2"
							title="Sair"
							onClick={logout}
						>
							<FaSignOutAlt className="fs-3" />
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export { AsideToolbar };
